<template>
  <div>
  <div class="root" id="root" data-target="specialFeature-1691834599183">
    <div class="hCnVKxh5ABYzPjWWu0rH">
      <div class="zAsCjLdh1d8SdqBcjnJY">

      </div>
      <div id="captcha-button"></div>
      <div id="captcha-element"></div>
      <div id="captcha-wy"></div>

      <div class="EwtG5SVBu1uEx_sudqYQ header-include">
        <div class="contents deposit-contents">
          <div class="choose-payment">
            <p class="choose-box">请选择充值渠道：
<!--              <i class="hiBtn"></i>-->
            </p>
<!--            <div class="choose-right">-->
<!--              <div class="tutorial-box" style="margin-right: 2px"   @click="$parent.goNav('/wenInfo?id=21')"><span class="scam-icon"></span><span> 防骗教程</span></div>-->
<!--              <div class="tutorial-box"   @click="$parent.goNav('/wenInfo?id=22')"><span class="tutorial-icon"></span><span> 充值教程</span></div>-->
<!--            </div>-->
          </div>


          <div class="payment-list">

            <div  v-if="payWayList.aiusdt == 1"  :class="pay_way == 'ZIDONGUSDT' ? ' payment-item actived false' : 'payment-item false false'" @click="changPayway('ZIDONGUSDT')" >
              <img class="payment-icon" src="/uploads/bankimg/1712903483_9831.png">
              <div class="name ellipsis">USDT自动</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend"></span></div>
            </div>

            <div  v-if="payWayList.usdt == 1"  :class="pay_way == 'USDT' ? ' payment-item actived false' : 'payment-item false false'" @click="changPayway('USDT')" >
              <img class="payment-icon" src="/uploads/bankimg/1712903483_9832.png">
              <div class="name ellipsis">USDT</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend"></span></div>
            </div>

<!--            v-if="payWayList.card == 1"-->
            <div  v-if="payWayList.card == 1"  :class="pay_way == 'BANK' ? ' payment-item actived false' : 'payment-item false false'" @click="changPayway('BANK')">
              <img class="payment-icon" src="/uploads/bankimg/1712905652.png">
              <div class="name ellipsis">银行卡充值</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend"></span></div>
            </div>

            <div   v-if="payWayList.is_re_szrmb_open == 1"   :class="pay_way == 'XZRMB' ? ' payment-item actived false' : 'payment-item false false'"    @click="changPayway('XZRMB')"   class="payment-item false false">
              <img class="payment-icon" src="/uploads/bankimg/1713762106.png">
              <div class="name ellipsis">数字人民币</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend"></span></div>
            </div>
            <div   v-if="payWayList.is_re_zfblq_open == 1"  :class="pay_way == 'ZFB' ? ' payment-item actived false' : 'payment-item false false'" @click="changPayway('ZFB')"  class="payment-item false last">
              <img class="payment-icon" src="/uploads/bankimg/1713929996.png">
              <div class="name ellipsis">支付宝A</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend"></span></div>
            </div>

            <div   v-if="payWayList.is_re_wx_open == 1"   :class="pay_way == 'WX' ? ' payment-item actived false' : 'payment-item false false'"  @click="changPayway('WX')"    class="payment-item false last">
              <img class="payment-icon" src="/uploads/bankimg/222222.png">
              <div class="name ellipsis">微信</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend"></span></div>
            </div>

<!--            <div     :class="pay_way == 'SIHAI' ? ' payment-item actived false' : 'payment-item false false'"  @click="changPayway('SIHAI')"    class="payment-item false last">-->
<!--              <img class="payment-icon" src="/uploads/bankimg/222222.png">-->
<!--              <div class="name ellipsis">四海支付</div>-->
<!--              <div class="payment-tag"><span class="fire-img"></span><span class="recommend"></span></div>-->
<!--            </div>-->

<!--            <div      :class="pay_way == 'MEIDUSHA' ? ' payment-item actived false' : 'payment-item false false'"  @click="changPayway('MEIDUSHA')"    class="payment-item false last">-->
<!--              <img class="payment-icon" src="/uploads/bankimg/222222.png">-->
<!--              <div class="name ellipsis">美杜莎支付</div>-->
<!--              <div class="payment-tag"><span class="fire-img"></span><span class="recommend"></span></div>-->
<!--            </div>-->
            <div     :class="pay_way == 'SIHAI' ? ' payment-item actived false' : 'payment-item false false'"  @click="changPayway('SIHAI')"    class="payment-item false last">
              <img class="payment-icon" src="/uploads/bankimg/1713929996.png">
              <div class="name ellipsis">支付宝B</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend"></span></div>
            </div>

            <div      :class="pay_way == 'MEIDUSHA' ? ' payment-item actived false' : 'payment-item false false'"  @click="changPayway('MEIDUSHA')"    class="payment-item false last">
              <img class="payment-icon" src="/uploads/bankimg/1713929996.png">
              <div class="name ellipsis">支付宝C</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend"></span></div>
            </div>


            <div  v-if="payWayList.is_re_wydc_open == 1" class="payment-item false false"><img class="payment-icon" src="/uploads/bankimg/1712903752.png">
              <div class="name ellipsis">网银代充</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend1"></span></div>
            </div>
            <div  v-if="payWayList.is_re_kuaichong_open == 1"   class="payment-item false false"><img class="payment-icon" src="/uploads/bankimg/1717553325.png">
              <div class="name ellipsis">银行卡快充</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend1"></span></div>
            </div>
            <div   v-if="payWayList.is_re_ebzl_open == 1"  class="payment-item false last"><img class="payment-icon" src="/uploads/bankimg/1713134316.png">
              <div class="name ellipsis">EB直连</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend1"></span></div>
            </div>
            <div   v-if="payWayList.is_re_etopay_open == 1"   class="payment-item false false"><img class="payment-icon" src="/uploads/bankimg/1712902691.png">
              <div class="name ellipsis">TOPAY</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend1"></span></div>
            </div>
            <div   v-if="payWayList.is_re_egobao_open == 1" class="payment-item false false"><img class="payment-icon" src="/uploads/bankimg/1712902967.png">
              <div class="name ellipsis">Gobao</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend1"></span></div>
            </div>
            <div   v-if="payWayList.is_re_okpay_open == 1" class="payment-item false false"><img class="payment-icon" src="/uploads/bankimg/1712903182.png">
              <div class="name ellipsis">Okpay</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend1"></span></div>
            </div>
            <div   v-if="payWayList.is_re_bobi_open == 1"  class="payment-item false last"><img class="payment-icon" src="/uploads/bankimg/1742549018.png">
              <div class="name ellipsis">BOBI</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend1"></span></div>
            </div>
            <div    v-if="payWayList.is_re_cnyi_open == 1"   class="payment-item false false"><img class="payment-icon" src="/uploads/bankimg/1712902394.png">
              <div class="name ellipsis">CNYT</div>
              <div class="payment-tag"><span class="fire-img"></span><span class="recommend1"></span></div>
            </div>







          </div>
          <div class="M8dRW6CpOtBocJbOnJpq">
            <div class="current-payment" v-if="pay_way == 'USDT'">
              <span>当前充值方式：</span><img src="/uploads/bankimg/1712903483.png">USDT
            </div>
            <div class="current-payment" v-else-if="pay_way == 'ZFB'">
              <span>当前充值方式：</span><img src="/uploads/bankimg/1713929996.png">支付宝
            </div>
            <div class="current-payment" v-else-if="pay_way == 'WX'">
              <span>当前充值方式：</span><img src="/uploads/bankimg/222222.png">微信
            </div>
            <div class="current-payment" v-else-if="pay_way == 'XZRMB'">
              <span>当前充值方式：</span><img src="/uploads/bankimg/1713762106.png">数字人民币
            </div>

            <ul class="payment-channel-list">

              <li v-for="(item, index) in code_list" :key="index" :class="recharge_id == item.id ? ' active' : 'false'" @click="changXiyi(item.id,item.content)" >{{item.content}}</li>

            </ul>
            <div id="amount-step">
              <div class="form-item">
                <h4>存款金额</h4>
                <div class="input-money error false"><input type="number" v-model="amount"
                                                            :placeholder="`请输入充值金额 ${min_price} - ${max_price}`" ></div>
              </div>
              <div class="quick-money-selector">
                <span   @click="changMoney(100)"  :class="amount == 100 ? ' usdt_money_active' : ''">100</span>
                <span   :class="amount == 500 ? ' usdt_money_active' : ''"   @click="changMoney(500)" >500</span>
                <span   :class="amount == 1000 ? ' usdt_money_active' : ''"  @click="changMoney(1000)" >1000</span>
                <span   :class="amount == 10000 ? ' usdt_money_active' : ''"  @click="changMoney(10000)" >10000</span>
              </div>
            </div>
<!--            <div class="tips">请先输入正确的金额!</div>-->
            <div style="font-size: 0.57rem;    color: rgba(47, 39, 71, 0.4);" class="tips normal usdt-tips"  v-if="pay_way == 'USDT' ||  pay_way == 'ZIDONGUSDT' ">
              <p>参考汇率  1USDT ≈ {{ $store.state.userInfo.usdtrate }}CNY</p>
              <p v-if="pay_way == 'USDT'  ">预计支付：<span>{{ amount ? Math.floor((amount / $store.state.userInfo.usdtrate) * 100) / 100 : '0.00' }}</span>USDT</p>
            </div>
            <div class="submit-box">
              <div v-if="amount > 0" class="action enable"  @click="payTest" id="next-step"></div>
              <div v-else-if="amount <= 0" class="action false" id="next-step"></div>
              <div class="tutorial" style="font-size: 0.579rem;    color: rgba(47, 39, 71, 0.4);">
                <p  style="    color: rgba(47, 39, 71, 0.4);"  v-if="pay_way == 'USDT'" >充值步骤</p>
<!--                <p  v-if="pay_way == 'USDT'" >充值步骤</p>-->
                <p   style="    color: rgba(47, 39, 71, 0.4);" v-if="pay_way == 'USDT'"   @click="$parent.goNav('/wenInfo?id=23')">USDT充值教程</p>
              </div>
              <ul v-if="pay_way == 'USDT'">
                <li>1. 请先下载注册USDT虚拟钱包账号。</li>
                <li>2. 登录USDT虚拟钱包账号，并购买适量的USDT。</li>
                <li>3. 在USDT虚拟钱包中通过【转账】进行进行扫码支付或输入收款地址进行支付。</li>
                <li>4.平台填写金额应当与汇款金额完全一致，否则将无法及时到账。</li>
              </ul>
            </div>
          </div>

          <div class="M4lJQ_sV7uLZLg8kprhT" v-if="pay_way == 'USDT'">
            <p>温馨提示：</p>
            <p>1、当前汇率仅供参考，实际到账金额以到账时汇率进行计算。</p>
            <p>
              2、请不要向转账地址充值任何非我司Tron (TRC20)，Ethereum
              (ERC20)，汇旺地址，目前仅支持以上三个个类型USDT，请勿转入非以上链USDT，否则资产将可能无法找回。</p>
            <p>
              3、请不要直接使用交易所的线上地址进行转账，如因直接转账，造成交易所账号被风控或者冻结，需玩家自行负责。</p>
            <p>
            </p>
          </div>
          <div class="M4lJQ_sV7uLZLg8kprhT" v-else>
            <p>温馨提示：</p>
            <p>＊请按照充値页提示操作，否则将可能造成充值延迟到账或到账失败的情况。</p>
            <p>＊请务必仔细核对您要充值的账号（用户名、手机号、游戏角色ID、绑定邮箱等）。充错账号通常无法撤销或退款。</p>
            <p> ＊警惕非官方渠道、不明链接、陌生人代充等，谨防诈骗、盗号、财产损失风险。</p>
              <p>＊非官方渠道充值可能导致账号封禁、充值不到账等问题，且难以维权。</p>
            <p>＊充值成功后，金额/点数通常会实时或短时间内到账。</p>
              <p> ＊如遇系统繁忙、高峰期或网络延迟，可能会有短暂延迟（一般在几分钟到几小时内）。</p>
            <p>＊请耐心等待，不要短时间内重复操作，以免造成重复扣款。</p>
            <p> ＊ 若长时间未到账（如超过24小时），请及时联系客服并提供凭证。</p>
            <p>＊充值完成后，请务必妥善保存充值成功的订单号、支付凭证（截图、交易流水号/商户单号）。<p>
              <p> ＊这是查询订单状态、解决充值问题（如不到账）的关键依据。</p>
              <p> ＊ 留意官方发布的充值相关公告，了解最新的支付方式、优惠活动、系统维护时间等信息，避免在维护期间充值。</p>
            <p  v-if="pay_way == 'USDT'"   @click="$parent.goNav('/wenInfo?id=23')">充值教程</p>
            <p>
            </p>
            <p>
            </p>
          </div>

        </div>
        <div class="nrhEsOIeYRqkdVly_o2C" style="z-index: 1;">
          <div class="guide-bg-container">
            <div class="bg-box">
              <div id="anchor-bg1"></div>
              <div id="anchor-bg2"></div>
              <div id="anchor-bg3"></div>
              <div id="anchor-bg4"></div>
              <div id="anchor-bg5"></div>
              <div id="anchor-bg6"></div>
            </div>
          </div>
          <div class="react-joyride"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="portal-warpper">
    <div class="HZ0Aws4BaQP_ZM85k_mS undefined" style="display: flex;">
      <div class="left"  @click="$router.back()"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left"
                             class="svg-inline--fa fa-chevron-left " role="img" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 320 512" style="margin: 0px 4px;">
        <path fill="currentColor"
              d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z">
        </path>
      </svg></div>
      <div class="center">充值</div>
      <div class="right">
        <div class="IfxrJcB7E96uA2r0VGH9"><span >
  					<div @click="$parent.goNav('/kefu')"  class="img-cs"></div>
  				</span><span   >
  					<div @click="$parent.goNav('/kefu')" class="img-feedback"></div><span></span>
  				</span>
          <span><img    @click="$parent.goNav('/message')" class="message" src="/webx/xc/mobile/images/precache/message_icon.fb7f.png"></span>
        </div>
      </div>
    </div>
  </div>
<!--    @click="$parent.goNav('/kefu')"-->


    <div v-if="is_vip_addbank" class="fg6ZfskHOnqaRwP2znAd block global-overlay" style="z-index: 200;">
      <div class="CcZmMdYWZeh7OF0CJm6z undefined undefined">
        <div class="header">
          <div>温馨提示</div><span @click="is_vip_addbank = false" class="close"></span><svg  @click="is_vip_addbank = false"  aria-hidden="true" focusable="false" data-prefix="fas"
                                                                                          data-icon="xmark" class="svg-inline--fa fa-xmark " role="img" xmlns="http://www.w3.org/2000/svg"
                                                                                          viewBox="0 0 384 512" style="margin: 0px 4px;">
          <path fill="currentColor"
                d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z">
          </path>
        </svg>
        </div>
        <div class="contents">必须达到VIP2，才能进行银行卡充值。</div>
        <div class="actions">
          <button  @click="is_vip_addbank = false"class="yes" color="secondary">关闭</button>
        </div>
      </div>
    </div>


    <div v-if="is_addbank" class="fg6ZfskHOnqaRwP2znAd block global-overlay" style="z-index: 200;">
      <div class="CcZmMdYWZeh7OF0CJm6z undefined undefined">
        <div class="header">
          <div>温馨提示</div><span @click="is_addbank = false" class="close"></span><svg  @click="is_addbank = false"  aria-hidden="true" focusable="false" data-prefix="fas"
                                                             data-icon="xmark" class="svg-inline--fa fa-xmark " role="img" xmlns="http://www.w3.org/2000/svg"
                                                             viewBox="0 0 384 512" style="margin: 0px 4px;">
          <path fill="currentColor"
                d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z">
          </path>
        </svg>
        </div>
        <div class="contents">请先绑定个人信息</div>
        <div class="actions">
          <button  @click="goaddbank" class="yes" color="secondary">绑定银行卡</button></div>
      </div>
    </div>



    <div v-if="is_usdt_pay" class="fg6ZfskHOnqaRwP2znAd block global-overlay" style="z-index: 99999;">
      <div class="IMXCn5ydwEw_jJmmMHBA"></div>
      <div class="xB_gF9WZa7pfIzh7CjSA popup-wrapper false deposit-popup"
           style="top: 32%; height: 68%; background-image: url(&quot;&quot;); background-size: 100%; background-repeat: no-repeat; background-color: rgb(255, 255, 255);">
        <div class="title deposit-header">{{pay_way}} ({{meyXi}})充值<p class="r-box"><i   @click="$parent.goNav('/kefu')"  class="kefu"></i>
          <i @click="is_usdt_pay = false" class="close"></i></p>
        </div>
        <div class="wrapper rQf8Kx2_t1s6G9S7vLzB">
          <div class="contents ">
            <div class="detail-info">
              <div class="detail-top">
                <div class="deposit-number"><span class="number">{{ payInfo.info.real_money }}</span><span class="unit">个</span>
                </div>
                <span class="step2Copy"></span>
                <div class="deposit_tip">仅支持{{pay_way}} ({{meyXi}})转账，其它支付方式无法到账。</div>
              </div>
            </div>
            <div class="white-bg" style="margin-top: -0.6rem;">
              <div class="deadline"><span class="deadline-icon"></span>
                <div>
                  <div>充值申请提交成功 </div>
                  <div>请在<span>{{ m >= 10 ? m : `0${m}` }}：{{ s >= 10 ? s : `0${s}` }}</span>内完成支付</div>
                </div>
              </div>
              <div class="qr-code">
                <div class="info" style="margin-top: -0.5rem;"  >
                  <div class="title">
                    <p v-if="type == 'usdtpay'">收款钱包地址：</p>
                    <p v-else >收款地址：</p>

                    <em class="type">{{pay_way}} - ({{meyXi}})</em>
                  </div>
                  <div class="code-url-box">
                    <p class="code-url">{{ payInfo.cardlist.mch_id }}</p><span
                      @click="doCopy(payInfo.cardlist.mch_id)" class="rigcopy">复制</span>
                  </div>
                </div>

                <div class="image" v-if="payInfo.cardlist.payimg">
                  <div class="qrcode">
                    <img :src="payInfo.cardlist.payimg" style="width: 150px;height: 150px" alt="" />



                  </div>
                  <p>如果二维码不显示，请您再试一次</p>
                </div>
                <div @click="is_usdt_pay = false" class="submit">我已充值</div>
              </div>
              <div class="tips">
                <div class="lightTipsTexts  warning">注意事项：</div>
                <p class="Texts_p">1.请不要保留收款账号或二维码进行重复充值，否则可能造成充值失败，感谢您的配合。</p>
                <p class="Texts_p">2.高峰期若充值订单处理时间过长或多个充值订单未处理，请联系客服为您手动处理充值订单。</p>
              </div>
            </div>
            <div class="detail-info white-bg" v-if="pay_way == 'USDT'">
              <div class="tips">
                <div class="lightTipsTexts warning">重要提示：</div>
                <p class="Texts_p"    >
                  进行USDT转账时请注意<span>手续费金额</span>及<span>到账金额</span>，<span>到账金额</span>必须与充值USDT个数一致，否则可能造成充值失败，感谢您的配合。<br>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="is_bank_pay" class="fg6ZfskHOnqaRwP2znAd block global-overlay" style="z-index: 12;">
      <div class="Zs5THLqQY4yVfXvDwk9p popup-wrapper false popup_fixed " style="top: 2%; height: 913.36px; background-image: url(&quot;&quot;); background-size: 100%; background-repeat: no-repeat; background-color: rgb(255, 255, 255);">
        <div class="dXKrZR0vnzQaeb_ExfRi">
          <div class="left" @click="ssss">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="svg-inline--fa fa-chevron-left " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style="margin: 0px 4px;"><path fill="currentColor" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"></path></svg>
          </div>
          <div class="center">银行卡充值</div>
          <div class="right"  @click="$parent.goNav('/banklist')" style="visibility: visible;"><img src="/webx/xc/mobile/images/precache/ic-newpage.4f13.png"></div>
        </div>
        <div class="wrapper op-popup">


          <div data-v-e386b449="" class="v-container v-locale--is-ltr mobileArea" id="test" style="">
            <form data-v-e386b449="" class="v-form" novalidate="" style="margin-bottom: 200px;">
              <div data-v-e386b449="" class="mb-3">
                <div data-v-e386b449=""
                     class="v-card v-theme--light v-card--density-default v-card--variant-elevated card-inner h-100">
                  <!---->
                  <!----><!---->
                  <div data-v-e386b449="" class="v-row pa-3 justify-center align-center">
                    <div data-v-e386b449="" class="v-col-sm-6 v-col-12 pa-0 pr-sm-3 mb-3 mb-sm-0">
                      <div data-v-e386b449="" class="input-group"><span data-v-e386b449=""
                                                                        class="d-flex align-center field-title">付款人姓名</span>
                        <div data-v-e386b449="" class="d-flex field-title-input-name">
                          <div style="border-bottom: 1px solid #EFEFEF">
                            <van-cell-group>
                              <van-field v-model="bankBox.bank_owner" type="text" placeholder="请输入付款人姓名"> </van-field>
                            </van-cell-group>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div id="bankcardList" class="row g-1 amount-btn" style="display: flex;width: 100%;overflow-x: auto; white-space: nowrap;margin-top: 5px;">
                      <div class="col-6 col-md-3 " style="margin-right: 30px;"  v-for="(item, index) in usercardLis" :key="index" @click="changApiType(item)">
                        <div :class="bankId == item.id ? ' btn btn-primary active btn-card2 bankcard' : 'btn btn-primary  btn-card2 bankcard'"  data-value="6217003370015894924">

                          <p class="text01">
                            {{ item.bank_address }}
                          </p>

                          <p class="text02">{{ item.bank_no }}</p>
                        </div>
                      </div>


                    </div>
                    <div v-if="bankInfo" id="bankcardList" class="row g-1 amount-btn" style="width: 100%;">
<!--                      <p class="text01">付款信息：</p>-->
                          <p class="text01" style="font-size: 14px;padding-top: 7px;">
                            开户行：{{ bankInfo.bank_address }}
                            <span  @click="doCopy(bankInfo.bank_address)" style="float: right;color: #A787E7">复制</span>
                          </p>
                      <p class="text01" style="font-size: 14px;padding-top: 7px;">
                        姓名：{{ bankInfo.bank_owner }}
                        <span  @click="doCopy(bankInfo.bank_owner)" style="float: right;color: #A787E7">复制</span>
                      </p>
                      <p class="text01" style="font-size: 14px;padding-top: 7px;">
                        卡号：{{ bankInfo.bank_no }}
                        <span  @click="doCopy(bankInfo.bank_no)" style="float: right;color: #A787E7">复制</span>
                      </p>
                      <p class="text01" style="font-size: 14px;padding-top: 7px;">
                        支行信息：{{ bankInfo.bank_address }}
                        <span  @click="doCopy(bankInfo.bank_address)" style="float: right;color: #A787E7">复制</span>
                      </p>
                    </div>



                  </div><!----><!----><span class="v-card__underlay"></span>
                </div>
              </div><!---->
              <div data-v-e386b449="" class="mb-3">
                <div data-v-e386b449=""
                     class="v-card v-theme--light v-card--density-default v-card--variant-elevated h-100 card-inner"
                     style="margin-bottom: 50px;"><!---->
                  <!----><!---->
                  <div data-v-e386b449="">
                    <div data-v-e386b449="" class="v-container v-locale--is-ltr pa-0">
                      <div data-v-e386b449="">
                        <div data-v-e386b449="" style="display: flex; justify-content: space-between;width: 100%">
                          <div data-v-e386b449="" class="v-col-sm-9 v-col-lg-10 v-col-5 pa-0">
                            <p data-v-e386b449="" class="mb-0"
                               style="color: var(--v-theme-fieldTitle);"> 快速充值金额 </p>
                          </div>
                          <div data-v-e386b449="" class="v-col d-flex justify-end pa-0" style="float: right;">
                            <button    @click="$parent.goNav('/wenInfo?id=26')"
                              data-v-e386b449="" type="button"
                              class="v-btn v-btn--elevated v-theme--light v-btn--density-default v-btn--size-default v-btn--variant-elevated btnCustom ml-3 rounded"
                              style="height: 32px !important; width: 116px;border: 1px solid #A787E7;background: #A787E7;color: #fff"><span  class="v-btn__content"
                                                                          data-no-activator=""> 充值教程指引 </span><!----><!----></button></div>

                        </div>

                       <div data-v-e386b449="" class="v-col v-col-12 d-block py-2 pt-sm-0 px-0">
                                                    <p data-v-e386b449=""
                                                       class="mb-3 font-weight-bold text-justify hint-text" style="color: red;font-weight: 700;">
                                                      支付宝及微信支付方式易受风控限制导致支付失败，建议使用USDT进行充值。 </p>
                      </div>
                        <div data-v-c43cc192="" class="quick-money-selector" style="padding: 10px 0px; ">
                          <span   @click="ccamount(100)"  :class="amount == 100 ? ' usdt_money_active' : ''" data-v-c43cc192="" >100</span>
                          <span   @click="ccamount(200)"   :class="amount == 200 ? ' usdt_money_active' : ''" data-v-c43cc192="" >200</span>
                          <span   @click="ccamount(300)"   :class="amount == 300 ? ' usdt_money_active' : ''" data-v-c43cc192="" >300</span>
                          <span   @click="ccamount(500)"   :class="amount == 500 ? ' usdt_money_active' : ''" data-v-c43cc192="" >500</span>
                          <span   @click="ccamount(1000)"   :class="amount == 1000 ? ' usdt_money_active' : ''" data-v-c43cc192="" >1000</span>
                          <span   @click="ccamount(1500)"   :class="amount == 1500 ? ' usdt_money_active' : ''" data-v-c43cc192="" >1500</span>
                          <span   @click="ccamount(2000)"   :class="amount == 2000 ? ' usdt_money_active' : ''" data-v-c43cc192="" >2000</span>
                          <span   @click="ccamount(3000)"   :class="amount == 3000 ? ' usdt_money_active' : ''" data-v-c43cc192="" >3000</span>
                          <span   @click="ccamount(5000)"   :class="amount == 5000 ? ' usdt_money_active' : ''" data-v-c43cc192="" >5000</span>
                          <span   @click="ccamount(6000)"   :class="amount == 6000 ? ' usdt_money_active' : ''" data-v-c43cc192="" >6000</span>
                          <span   @click="ccamount(7000)"   :class="amount == 7000 ? ' usdt_money_active' : ''" data-v-c43cc192="" >7000</span>
                          <span   @click="ccamount(8000)"   :class="amount == 8000 ? ' usdt_money_active' : ''" data-v-c43cc192="" >8000</span>
                          <span   @click="ccamount(9000)"   :class="amount == 9000 ? ' usdt_money_active' : ''" data-v-c43cc192="" >9000</span>
                          <span   @click="ccamount(10000)"   :class="amount == 10000 ? ' usdt_money_active' : ''" data-v-c43cc192="" >10000</span>
                          <span   @click="ccamount(15000)"   :class="amount == 15000 ? ' usdt_money_active' : ''" data-v-c43cc192="" >15000</span>
                          <span   @click="ccamount(20000)"   :class="amount == 20000 ? ' usdt_money_active' : ''" data-v-c43cc192="" >20000</span>
                        </div>

                        <div data-v-e386b449="" style="display: flex; justify-content: space-between;width: 100%">
                          <div data-v-e386b449="" class="v-col-sm-9 v-col-lg-10 v-col-5 pa-0">
                            <p data-v-e386b449="" class="mb-0"
                               style="color: var(--v-theme-fieldTitle);">  充值申请金额  </p>
                          </div>
                          <div data-v-e386b449="" class="v-col d-flex justify-end pa-0" style="float: right;">
                            <div style="width: 20px;background-color: #EFEFEF;height: 28px;line-height: 28px;text-align: center;color: #000">￥</div>
                            <div style="width: 200px;;height: 28px;line-height: 28px;background-color: #EFEFEF;padding-left: 15px">{{amount}}</div>
                          </div>
                        </div>


                        <div @click="payTest" data-v-e386b449="" class="mobile-btn" style="padding: 10px 12px;margin-bottom: 00px">
                          <div data-v-e386b449="" class="v-row d-flex justify-center" style="padding: 10px 0px;"><button
                              data-v-e386b449="" type="button"
                              class="v-btn v-btn--elevated v-theme--light v-btn--density-default v-btn--size-default v-btn--variant-elevated btnCustom btn-mobile rounded fontSize-16"
                              style="width: 96%;height: 44px"><span class="v-btn__overlay"></span><span
                              class="v-btn__underlay"></span><!----><span class="v-btn__content" data-no-activator="">
          					我已充值 </span><!----><!----></button></div>
                        </div>

                      </div>


                    </div>
                  </div>
                </div>
              </div>



            </form>

          </div>


        </div>
      </div>
    </div>

    <div v-if="show" style="position: fixed; width: 100%; height: 100%; top: 0; z-index: 999; background: rgba(0, 0, 0, 0.39)">
        <van-picker style="position: absolute; bottom: 0; left: 0; width: 100%" title="银行类型" show-toolbar :columns="banklist" @confirm="onConfirm" @cancel="onCancel" @change="onChange" value-key="bank_name" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'recharge',
  data() {
    return {
      showname:'',
      showbank:"",
      usercardLis:[],

      is_vip_addbank:false,
      is_bank_pay:false,
      is_usdt_pay:false,
      is_addbank:false,
      pay_way: '',
      bankBox: {},
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [],
      bankBox: {},
      meyXi: '',
      payWayList: {},
      show: false,
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,

      type: null,
      daoTime: null,
      m: 0,
      s: 0,


      recharge_id:0,
      bankId:0,
      bankInfo:{},

      code_list:[],

    };
  },
  created() {
    let that = this;
    // that.getpaycodelist();
    that.getPayWay();
    that.getBanklist();
    // that.getcard();
  },
  methods: {
    ccamount(money){
      this.amount = money
    },
    getpaycodelist(){
      let that = this;
      that.showLoading();
      that.$apiFun
          .post('/api/getPayCode', {
            type:that.pay_way
          })
          .then(res => {
            if (res.code == 200) {
                that.code_list = res.data.code_list;
                if(that.code_list.length > 0){
                  // that.changXiyi(that.code_list[0].id,that.code_list[0].content)


                  that.meyXi = that.code_list[0].content;
                  that.getPayRange(that.code_list[0].id);


                  // that.getPayRange(that.code_list[0].id);
                }

            }
            that.hideLoading();
          })
          .catch(res => {
            that.hideLoading();
          });
    },
    goaddbank(){
      this.is_addbank = false;
      this.$parent.goNav('/addBankCard')
    },
    changMoney(val){
      this.amount = val;
    },
    getPayRange(id) {
      let that = this;
      this.recharge_id = id;
      that.showLoading();

      that.$apiFun
          .post('/api/getPayRange', {
            id:id
          })
          .then(res => {
            if (res.code == 200) {
              that.min_price = res.data.min_price;
              that.max_price = res.data.max_price;
            }
            that.hideLoading();
          })
          .catch(res => {
            that.hideLoading();
          });
    },
    changShow() {
      this.show = !this.show;
    },
    onConfirm(value, index) {
      this.showbank = value.bank_name;

      this.bankBox.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.show = false;
    },
    changXiyi(id,val) {

      if (this.meyXi == val) {
        return;
      }
      this.meyXi = val;
      this.getPayRange(id);
    },
    changApiType(e) {

      this.bankId = e.id;
      this.bankInfo = e;

    },
    getPayWay() {
      let that = this;
      that.showLoading();

      that.$apiFun
          .get('/api/get_pay_way', {})
          .then(res => {
            if (res.code == 200) {
              that.payWayList = res.data;
              that.payWayList.rengong = 1;
              let obj = that.payWayList;
              for (let i in obj) {
                if (obj[i] == 1) {
                  that.pay_way = 'ZIDONGUSDT';
                  that.hideLoading();
                  that.getpaycodelist();

                  return;
                }
              }
            }
            that.hideLoading();
          })
          .catch(res => {
            that.hideLoading();
          });
    },
    payTest() {
      let that = this;
      let info = {};

      // bank 情况下  bank  bank_address  bank_no  bank_owner
      if (that.pay_way == 'BANK') {
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        console.log(info);
        // 银行卡信息内容的限制
        if (!info.bank_owner) {
          that.showTost(0, '请输入付款人姓名');
          return;
        }
        // if (!info.bank) {
        //   that.showTost(0, '请输入银行类型');
        //   return;
        // }
        //
        // if (!info.bank_no) {
        //   that.showTost(0, '请输入银行卡号');
        //   return;
        // }
        // if (!info.bank_address) {
        //   that.showTost(0, '请输入银行开户行地址');
        //   return;
        // }
      } else {
        //暂时
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
        };
      }
      if (that.pay_way == 'USDT') {
        info.catepay = that.meyXi;
      }
      // usdt 情况下  catepay 必填

      // 支付的金额判断
      if (info.amount < that.min_price || info.amount > that.max_price) {
        that.showTost(0, `请输入金额在${that.min_price}-${that.max_price}之间！`);
        return;
      }
      that.showLoading();
      info.paytype = info.paytype == 'wechat' ? 'wxpay' : info.paytype;
      info.recharge_id = that.recharge_id
      that.$apiFun
          .post('/api/recharge', info)
          .then(res => {
            console.log(res);
            if (res.code != 200) {
              that.showTost(0, res.message);
            }
            if (res.code == 200) {
              that.amount = null;
              if (that.pay_way == 'BANK') {
                that.showTost(1, '提交成功，等待后台审核');
                that.bankBox = {};
                that.amount = null;
                that.hideLoading();
                that.$router.push({
                  path: '/transRecord'
                });
                return;
              } else if (that.pay_way == 'MEIDUSHA') {
                that.bankBox = {};
                that.amount = null;
                that.hideLoading();
                that.$router.push({
                  path: '/gamePage?pay_url='+res.data.payData
                });
                return;
              } else if (that.pay_way == 'SIHAI') {
                that.bankBox = {};
                that.amount = null;
                that.hideLoading();
                that.$router.push({
                  path: '/gamePage?pay_url='+res.data.payData
                });
                return;
              }


              that.bankBox = {};

              that.amount = null;
              that.getpayinfo(res.message);
              // that.$router.push({
              //   path: `/payInfo?deposit_no=${res.message}`
              // });
            }
            that.hideLoading();
          })
          .catch(res => {
            that.hideLoading();
          });
    },
    getpayinfo(deposit_no) {
      let that = this;
      this.$parent.showLoading();

      that.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.is_usdt_pay = true;
          that.payInfo = res.data;
          that.type = res.message;
          that.countTime();
        }
        this.$parent.hideLoading();
      });
    },
    changMey(val) {
      this.amount = val * 1;
    },
    getBanklist() {
      let that = this;
      that.$apiFun
          .post('/api/banklist', {})
          .then(res => {
            if (res.code != 200) {
              that.showTost(0, res.message);
            }
            if (res.code == 200) {
              that.banklist = res.data;
            }
            that.hideLoading();
          })
          .catch(res => {
            that.hideLoading();
          });
    },
    getcard() {
      let that = this;
      that.showLoading();
      that.$apiFun
          .post('/api/getpaybank', {})
          .then(res => {
            if (res.code != 200) {
              that.showTost(0, res.message);
            }
            if (res.code == 200) {
              that.cardLis = res.data;

              that.hideLoading();
            }
          })
          .catch(res => {
            that.hideLoading();
          });
    },
    ssss(){
      this.is_bank_pay = false;
      this.changPayway('USDT');
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) {
        return;
      }
      if(val == 'BANK' && that.$store.state.userInfo.current_vip_number < 2){
          this.is_vip_addbank = true;
        return;
      } else if(val == 'BANK' && this.userbank.length == 0 && this.userUSD.length == 0){
          this.is_addbank = true;
          return;
      } else if(val == 'BANK'){

        that.getbanklist();

         this.is_bank_pay = true;
         that.getPayRange(0);
      }

      that.pay_way = val;
      that.bankBox = {};
      that.payInfo = {};
      that.amount = null;
      if(val != 'BANK'){
        that.getpaycodelist()
      }
    },
    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    doBankCopy(e){
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = e.bank_address + '  ' + e.bank_owner + '  ' + e.bank_no  + '  ' + e.bank_address  ;



      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.showTost(1, '复制成功！');
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.showTost(1, '复制成功！');
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    countTime() {
      //获取当前时间
      let that = this;
      var date = new Date();
      var now = date.getTime(); //当前时间
      //   创建时间
      let created_at = that.payInfo.info.created_at;
      let createdTime = new Date(created_at).getTime();
      //设置截止时间
      var end = createdTime + 1000 * 60 * 60;
      //时间差
      var leftTime = end - now;

      //定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // that.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        that.m = Math.floor((leftTime / 1000 / 60) % 60);
        that.s = Math.floor((leftTime / 1000) % 60);
      } else {
        // $('.time').html('00:00');
        clearInterval(that.countTime);
        that.countTime = null;

        return;
      }
      let m = that.m >= 10 ? that.m : `0${that.m}`;
      let s = that.s >= 10 ? that.s : `0${that.s}`;
      // $('.time').html(`${m}:${s}`);
      //递归每秒调用countTime方法，显示动态时间效果
      setTimeout(this.countTime, 1000);
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    getbanklist() {
      let that = this;
      that.$apiFun.post('/api/getcard', {
        type: 99
      }).then(res => {
        if (res.code == 200) {
          that.usercardLis = res.data;
          that.bankId = that.usercardLis[0].id
          that.bankInfo = that.usercardLis[0];
        }
      });
    },
    getuseCardlist() {
      let that = this;
      that.$apiFun.post('/api/getcard', {
        type: 'BANK'
      }).then(res => {
        if (res.code == 200) {
          that.userbank = res.data;
        }
      });
      that.$apiFun.post('/api/getcard', {
        type: 'USDT'
      }).then(res => {
        if (res.code == 200) {
          that.userUSD = res.data;
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.countTime) {
      clearInterval(that.countTime);
    }
    that.countTime = null;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(vm);
      let that = this;
      vm.getuseCardlist();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '/style.css';


.bobycc {
  font-size: 12px;
}

body>div#root {
  height: 100%;
  overflow: hidden;
  background-color: #fafaff;
}

body>div#root>div {
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: auto;
}

.hCnVKxh5ABYzPjWWu0rH {
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: repeat;
  background: #fff;
}

div, span, a {
  user-select: none;
  -webkit-overflow-scrolling: touch;
}


.overlay {
  width: 100%;
  height: 100vh;
  opacity: 0;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 100;
  overflow: hidden;
}

.zAsCjLdh1d8SdqBcjnJY .overlay {
  width: 100%;
  height: 100vh;
  opacity: 0;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 100;
  overflow: hidden;
}

.fBzbGiSmgDKW5YKdSO19 .rndxs {
  position: relative;
  z-index: 199;
}

.EwtG5SVBu1uEx_sudqYQ.header-include {
  height: calc(100% - 2.4rem);
  box-sizing: border-box;
  margin-top: 2.4rem;
  position: relative;
  overflow: auto;
}

.EwtG5SVBu1uEx_sudqYQ>.contents {
  position: relative;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  scroll-behavior: smooth;
  z-index: 2;
}

.EwtG5SVBu1uEx_sudqYQ.header-include>.contents {
  padding: 18px 0 2rem;
  background: url(/webx/xc/mobile/images/precache/bg.c141.png) no-repeat left bottom;
  background-size: 100% auto;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.choose-payment {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: .7467rem;
  height: 1.7rem;
  color: #593f6c;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 .7467rem;
  margin-bottom: 10px;
}

h1, h2, h3, h4, h5, h6, ul, dl, dt, dd, ol, p, input {
  margin: 0;
  padding: 0;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.choose-payment .choose-box {
  line-height: 1.7rem;
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  align-items: center;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.choose-payment .hiBtn {
  background: url(/webx/xc/mobile/images/precache/hi-btn.10c5.png) no-repeat;
  display: inline-block;
  height: 1.38rem;
  width: 3.73rem;
  background-size: 100% 100%;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.choose-payment .choose-right {
  display: flex;
  justify-content: flex-end;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.choose-payment .tutorial-box {
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  display: flex;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.choose-payment .tutorial-box span {
  font-size: .6rem;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.choose-payment .tutorial-box .scam-icon {
  background: url(/webx/xc/mobile/images/precache/scam-icon.e4f7.png) no-repeat;
  background-size: 100% 100%;
  width: .7467rem;
  height: .7467rem;
  display: inline-block;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.choose-payment .tutorial-box span {
  font-size: .6rem;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.choose-payment .tutorial-box .tutorial-icon {
  background: url(/webx/xc/mobile/images/precache/tutorial-icon.54aa.png) no-repeat;
  background-size: 100% 100%;
  width: .7467rem;
  height: .7467rem;
  display: inline-block;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.payment-list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  padding-bottom: .4rem;
  padding: 0 .7467rem .4rem .7467rem;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.payment-list>div.payment-item {
  width: 23.5%;
  height: 3.6rem;
  margin-bottom: .2667rem;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #ededed;
  box-sizing: border-box;
  padding: 0px 3px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;
  margin-right: 2%;
  margin-right: 1.5%;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.payment-list>div.payment-item.actived {
  background: url(/webx/xc/mobile/svg/bank-bg.a441.svg) no-repeat;
  background-size: 100% 100%;
  border: none;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.payment-list>div.payment-item .payment-icon {
  width: 36px;
  height: 37px;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


.EwtG5SVBu1uEx_sudqYQ>.contents>.payment-list>div.payment-item .name {
  color: #2f2747;
  font-size: 12px;
  margin: 2px 0px;
  width: 100%;
  text-align: center;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.payment-list>div.payment-item>div.payment-tag {
  position: absolute;
  width: 100%;
  left: 2px;
  top: -2px;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.payment-list>div.payment-item>div.payment-tag>span.fire-img {
  display: inline-block;
  background: url(/webx/xc/mobile/svg/fire.ffdc.svg);
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 1.2rem;
  height: 1.2rem;
  position: absolute;
  left: .1867rem;
  top: .2667rem;
}
.EwtG5SVBu1uEx_sudqYQ>.contents>.payment-list>div.payment-item>div.payment-tag>span.fire-img {
  display: inline-block;
  background: url(/webx/xc/mobile/svg/fire.ffdc.svg);
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 1.2rem;
  height: 1.2rem;
  position: absolute;
  left: .1867rem;
  top: .2667rem;
}


.EwtG5SVBu1uEx_sudqYQ>.contents>.payment-list>div.payment-item>div.payment-tag>span.recommend {
  display: inline-block;
  background: url(/webx/xc/mobile/svg/recommend.35d6.svg);
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 100%;
  height: 3.6rem;
}
.EwtG5SVBu1uEx_sudqYQ>.contents>.payment-list>div.payment-item>div.payment-tag>span.recommend1 {
  display: inline-block;
  background: url(/webx/xc/mobile/svg/recommend.35d7.svg);
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 100%;
  height: 3.6rem;
}
.M8dRW6CpOtBocJbOnJpq {
  overflow: auto;
  position: relative;
  padding: .5rem .7467rem 0 .7467rem;
}



.M8dRW6CpOtBocJbOnJpq>div.current-payment, .M8dRW6CpOtBocJbOnJpq>div.bind-phone {
  display: flex;
  align-items: center;
  color: #2f2747;
  font-weight: bold;
  font-size: 13px;
}


.M8dRW6CpOtBocJbOnJpq>div.current-payment>span, .M8dRW6CpOtBocJbOnJpq>div.bind-phone>span {
  font-weight: normal;
  color: #2f2747;
  font-size: .7179rem;
  padding: .4rem 0;
}

.M8dRW6CpOtBocJbOnJpq>div.current-payment>img, .M8dRW6CpOtBocJbOnJpq>div.bind-phone>img {
  width: 32px;
  height: 32px;
}


.M8dRW6CpOtBocJbOnJpq>ul.payment-channel-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 10px;
  margin-top: -0.5rem;
}

.M8dRW6CpOtBocJbOnJpq>ul.payment-channel-list li {
  text-align: center;
  border-radius: 4px;
  background: linear-gradient(180deg, #faf9ff 0%, #eeebff 100%);
  color: #9486c4;
  padding: 0px 10px;
  min-width: 3.5rem;
  flex: none;
  margin-right: 8px;
  box-sizing: border-box;
  position: relative;
  margin-top: 1rem;
  font-size: .6153rem;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;
}

.M8dRW6CpOtBocJbOnJpq>ul.payment-channel-list li.active {
  border-radius: 4px;
  border: 1px solid #A787E7;
  background: #A787E7;
  color: #fff;
  position: relative;
}

.M8dRW6CpOtBocJbOnJpq .form-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.M8dRW6CpOtBocJbOnJpq .form-item>h4 {
  font-weight: normal;
  color: #2f2747;
  font-size: .7179rem;
  padding: .4rem 0;
  width: 4rem;
}

.M8dRW6CpOtBocJbOnJpq .bind-real-name, .M8dRW6CpOtBocJbOnJpq .input-money {
  border: 1px solid rgba(160, 149, 198, .2);
  height: 2rem;
  line-height: 2rem;
  padding-left: .5333rem;
  display: flex;
  box-sizing: border-box;
  flex: 1;
  margin-top: .2667rem;
  margin-bottom: .2667rem;
  position: relative;
  border-radius: 6px;
}

.M8dRW6CpOtBocJbOnJpq .bind-real-name>input, .M8dRW6CpOtBocJbOnJpq .input-money>input {
  width: 90%;
  height: 100%;
  line-height: 100%;
  border: 0;
  background-color: rgba(0, 0, 0, 0);
  font-weight: 400;
  font-size: 14px;
  color: #2f2747;
}

.M8dRW6CpOtBocJbOnJpq .quick-money-selector {
  box-sizing: border-box;
  border-radius: 0 0 2px 2px;
  border-top: none;
  margin: .2667rem 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: .4rem;
}



.M8dRW6CpOtBocJbOnJpq>.tips {
  margin: .1067rem 0;
  color: #d52626;
  padding-left: .8rem;
  background-size: auto;
  background-position: left top;
  background-repeat: no-repeat;
  background-image: url(/webx/xc/mobile/svg/red-warning.0b1e.svg);
}

.M8dRW6CpOtBocJbOnJpq>.tips {
  margin: .1067rem 0;
  color: #d52626;
  padding-left: .8rem;
  background-size: auto;
  background-position: left top;
  background-repeat: no-repeat;
  background-image: url(/webx/xc/mobile/svg/red-warning.0b1e.svg);
}

.M8dRW6CpOtBocJbOnJpq>.tips.normal {
  color: #2f2747;
}

.M8dRW6CpOtBocJbOnJpq>.tips.usdt-tips {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: none;
  padding-left: 0;
}

.M8dRW6CpOtBocJbOnJpq>.submit-box {
  margin-top: .64rem;
}

.M8dRW6CpOtBocJbOnJpq>.submit-box .tutorial {
  display: flex;
  justify-content: space-between;
}

.M8dRW6CpOtBocJbOnJpq>.submit-box .tutorial p {
  color: #2f2747;
  padding-left: .8rem;
  background-size: auto 100%;
  background-position: left center;
  background-repeat: no-repeat;
}

.M8dRW6CpOtBocJbOnJpq>.submit-box .tutorial p:first-child {
  background-image: url(/webx/xc/mobile/images/precache/warning.03d8.png);
}

.M8dRW6CpOtBocJbOnJpq>.submit-box ul {
  margin-top: .5rem;
  padding-bottom: 8px;
}

.M8dRW6CpOtBocJbOnJpq>.submit-box ul li {
  color: rgba(47, 39, 71, .4);
  line-height: 1.066rem;
  font-size: .64rem;
}

.EwtG5SVBu1uEx_sudqYQ>.contents .adds {
  width: calc(100% - 24px);
  margin: 0 auto;
  box-sizing: border-box;
  aspect-ratio: 4.7432432432;
}

.ixSeTP5dwImomokNAYGF {
  height: 100%;
}

.ixSeTP5dwImomokNAYGF>div {
  z-index: 1;
}

.ixSeTP5dwImomokNAYGF .embla {
  position: relative;
  background-color: #f7f7f7;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
}

.EwtG5SVBu1uEx_sudqYQ>.contents .adds .embla {
  border-radius: 12px;
  overflow: hidden;
  background: none;
}
.ixSeTP5dwImomokNAYGF .embla__viewport {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.ixSeTP5dwImomokNAYGF .embla__container {
  display: flex;
  user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  height: 100%;
}
.ixSeTP5dwImomokNAYGF .embla__slide {
  position: relative;
  flex: 0 0 100%;
  max-width: 100%;
  margin-left: 10px;
  height: 100%;
  background-size: 100% 100%;
}
.ixSeTP5dwImomokNAYGF .embla__slide {
  margin-left: 0;
}


.M4lJQ_sV7uLZLg8kprhT {
  margin-top: .5333rem;
  font-size: .64rem;
  line-height: 1.12rem;
  color: rgba(47, 39, 71, .4);
  padding: 0 .7467rem;
}


.EwtG5SVBu1uEx_sudqYQ>.contents>.hiwallert {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #857d7d;
  padding: .4rem .64rem .4rem 3.4rem;
  background: url(/webx/xc/mobile/images/precache/hiwallert-down.18b5.png) no-repeat .64rem center;
  background-size: auto 80%;
  box-sizing: border-box;
  margin-top: .64rem;
}

.EwtG5SVBu1uEx_sudqYQ>.contents>.hiwallert .hi-down-btn {
  padding: 0 1.2rem;
  color: #fff;
  height: 2.13333rem;
  line-height: 2rem;
  border-radius: 2rem;
  box-sizing: border-box;
  border: 2px solid #fff;
  background: linear-gradient(137deg, #5D6CF5 -4.17%, #5DD1F5 105.64%);
}

.nrhEsOIeYRqkdVly_o2C {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #fff;
}

.fBzbGiSmgDKW5YKdSO19 .rndxs .icon {
  width: 1.92rem;
  height: 1.92rem;
}

.HZ0Aws4BaQP_ZM85k_mS {
  height: 2.4rem;
  justify-content: space-between;
  align-items: center;
  display: flex;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 5;
  background: #fff;
  border-bottom: 1px solid rgba(217, 217, 217, .22);
}

.HZ0Aws4BaQP_ZM85k_mS>div.left {
  width: 10%;
}
.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}
.HZ0Aws4BaQP_ZM85k_mS>div.left>svg {
  font-size: .8533rem;
  padding: .64rem .4rem;
}
.HZ0Aws4BaQP_ZM85k_mS>div.center {
  position: absolute;
  left: 20%;
  width: 60%;
  text-align: center;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  color: #0c0319;
}
.HZ0Aws4BaQP_ZM85k_mS>div.right {
  width: 30%;
  display: flex;
  justify-content: flex-end;
}
.IfxrJcB7E96uA2r0VGH9 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.IfxrJcB7E96uA2r0VGH9>span {
  display: flex;
  width: 1.0667rem;
  margin-right: .5333rem;
  position: relative;
}
.IfxrJcB7E96uA2r0VGH9>span .img-cs {
  background: url(/webx/xc/mobile/svg/ic-kefu.181c.svg) no-repeat;
  background-size: 100% 100%;
  width: 1.0667rem;
  height: 1.0133rem;
}

.IfxrJcB7E96uA2r0VGH9>span .img-feedback {
  background: url(/webx/xc/mobile/svg/feedback_icon.e349.svg) no-repeat;
  background-size: 100% 100%;
  width: 1.0667rem;
  height: 1.0133rem;
}

.IfxrJcB7E96uA2r0VGH9>span>span {
  width: 8.5333rem;
  top: 1rem;
  left: -5.6rem;
  text-align: center;
  height: 2.4533rem;
  line-height: 2.4533rem;
  background: url(/webx/xc/mobile/images/precache/feedback-bg.c78c.png) no-repeat;
  background-size: 100% 100%;
  color: #9179e7;
  position: absolute;
  z-index: 10;
}

.IfxrJcB7E96uA2r0VGH9>span img {
  width: 1.0667rem;
}

.M8dRW6CpOtBocJbOnJpq>.submit-box>.action {
  height: 3.6rem;
  line-height: 2.6rem;
  background: url(/webx/xc/mobile/images/precache/btn-next-not-clickable.a7a9.png) no-repeat;
  font-size: 1.1rem;
  font-weight: bold;
  background-repeat: no-repeat;
  background-size: 100% auto;
  margin: 0 .5rem;
  text-align: center;
  letter-spacing: 5px;
  color: rgba(0, 0, 0, 0);
}

.M8dRW6CpOtBocJbOnJpq>.submit-box>.action.enable {
  background: url(/webx/xc/mobile/images/precache/btn-next.4012.png) no-repeat;
  background-size: 100% auto;
  color: #fff;
}


.fg6ZfskHOnqaRwP2znAd {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  top: 0;
  left: 0;
  position: fixed;
  transform: translateZ(500px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}


.block {
  display: block !important;
}

.CcZmMdYWZeh7OF0CJm6z {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: fixed;
  animation: fade-bottom-top .6s forwards;
  width: calc(100% - 2.67rem);
  max-height: calc(100% - 3.41rem);
  //background: url(/webx/xc/mobile/svg/popup-bg.368d.svg);
  //background-size: contain;
  height: 15.1467rem;
}


.CcZmMdYWZeh7OF0CJm6z {
  background: url(/webx/xc/mobile/images/outcache/popup-bg.08e4.png);
  //background-size: contain;
  //background-size: contain;
  background-size: 100% 100%;
}

.CcZmMdYWZeh7OF0CJm6z .header {
  padding: 0 1.066667rem;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  margin-top: 5.3rem;
}

.CcZmMdYWZeh7OF0CJm6z>.header {
  margin-top: 4.5rem;
}


div, span, a {
  user-select: none;
  -webkit-overflow-scrolling: touch;
}


.CcZmMdYWZeh7OF0CJm6z .header>svg {
  position: absolute;
  right: .72222rem;
  top: 2.7122222222rem;
  font-size: .853333rem;
  padding: .8rem;
}

.CcZmMdYWZeh7OF0CJm6z>.header>svg {
  top: 2rem;
}

.CcZmMdYWZeh7OF0CJm6z .contents {
  min-height: 2.5rem;
  max-height: 4rem;
  overflow: auto;
  box-sizing: border-box;
  padding: .4333rem 1rem;
  font-size: .8rem;
  line-height: 1.066667rem;
  text-align: center;
  color: rgba(47, 39, 71, .6);
  word-break: break-all;
}
.CcZmMdYWZeh7OF0CJm6z .actions {
  overflow: hidden;
  display: flex;
  justify-content: center;
  padding-bottom: .5333rem;
  border-radius: .5333rem;
  background-color: rgba(0, 0, 0, 0) !important;
}

.CcZmMdYWZeh7OF0CJm6z .actions>button {
  width: 5.9733rem;
  height: 2.24rem;
  color: #fff;
  margin: 0 .2667rem;
  background: url(/webx/xc/mobile/svg/confirm.8bcf.svg) no-repeat;
  background-size: contain;
  border-color: rgba(0, 0, 0, 0);
  font-size: .8533rem;
}



.fg6ZfskHOnqaRwP2znAd {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  top: 0;
  left: 0;
  position: fixed;
  transform: translateZ(500px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.IMXCn5ydwEw_jJmmMHBA {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
}


.xB_gF9WZa7pfIzh7CjSA {
  height: 100%;
  position: absolute;
  width: 100%;
  left: 0;
  z-index: 1;
  background: #fff;
  border-top-left-radius: 1.066667rem;
  border-top-right-radius: 1.066667rem;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, .2), 0px 24px 38px 3px rgba(0, 0, 0, .14), 0px 9px 46px 8px rgba(0, 0, 0, .12);
  //transform: translate3d(0, 100%, 0);
  animation: an-pop-up .5s forwards;
  overflow: hidden;
}
.deposit-popup {
  background: url(/webx/xc/mobile/images/precache/deposit_bg.ad03.png) !important;
  background-size: 100% auto !important;
  background-repeat: no-repeat !important;
}

div.deposit-popup {
  background-repeat: no-repeat !important;
  background-size: 100% auto !important;
}



.xB_gF9WZa7pfIzh7CjSA>.title {
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .746667rem;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  color: #4c4c4c;
  box-sizing: border-box;
  z-index: 2;
}
.deposit-popup .title {
  border-bottom: none;
  color: #fff;
}



.deposit-popup .deposit-header {
  height: 3.1875rem !important;
  font-size: 18px;
  font-weight: 500;
  font-family: "PingFang SC";
}



.deposit-popup .title {
  border-bottom: none;
  color: #fff;
}

.deposit-popup .deposit-header .r-box {
  position: absolute;
  right: .74666rem;
  top: 1.1rem;
}

.deposit-popup .deposit-header .r-box>i {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}

.deposit-popup .deposit-header .r-box .kefu {
  background-image: url(/webx/xc/mobile/svg/kefu.066a.svg);
}

.deposit-popup .deposit-header .r-box .close {
  margin-left: .8rem;
  background-image: url(/webx/xc/mobile/svg/close.d962.svg);
}

.rQf8Kx2_t1s6G9S7vLzB {
  padding: 0px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.xB_gF9WZa7pfIzh7CjSA>.wrapper {
  height: calc(100% - 3.1875rem);
  margin-top: 3.1875rem;
  overflow: scroll;
  overscroll-behavior: contain;
  box-sizing: border-box;
  position: relative;
}

.rQf8Kx2_t1s6G9S7vLzB>.contents {
  height: 100% !important;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.55), #FFFFFF), url(/webx/xc/mobile/images/precache/popup-content-bg.0725.png) no-repeat 15px -6px;
  background-size: 100%;
}

.xB_gF9WZa7pfIzh7CjSA>.wrapper>.contents {
  box-sizing: border-box;
  height: calc(100% - 2.67rem);
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  position: relative;
}

.rQf8Kx2_t1s6G9S7vLzB .detail-info {
  border-radius: .3733rem;
}

.rQf8Kx2_t1s6G9S7vLzB .detail-info .detail-top {
  padding: 1rem 1rem 0;
}

.rQf8Kx2_t1s6G9S7vLzB .detail-info .deposit-number {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: .8rem 0 0;
}
.rQf8Kx2_t1s6G9S7vLzB .detail-info .deposit-number>.number {
  font-size: 2.24rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  font-family: AkrobatBlack;
}
.rQf8Kx2_t1s6G9S7vLzB .detail-info .deposit-number>.unit {
  margin-bottom: .6rem;
  font-style: .7467rem;
  margin-left: .2667rem;
  font-weight: bold;
}

.rQf8Kx2_t1s6G9S7vLzB .step2Copy {
  color: #a17df5;
  font-size: .74667rem;
  padding-right: .4rem;
  position: relative;
  top: -32px;
  left: 90%;
}

.rQf8Kx2_t1s6G9S7vLzB .detail-info .deposit_tip {
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  color: #e07900;
  padding: .4rem 0;
  margin-top: -1.1rem;
}


.rQf8Kx2_t1s6G9S7vLzB .white-bg {
  padding: 0 1rem;
}

.rQf8Kx2_t1s6G9S7vLzB .deadline {
  padding: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATsAAAA+CAYAAABUZrzAAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC7SURBVHgB7dyxEYJAAADBx8q1ZGAcMt4ejIDbLeLCW7b9mAMAAAAAAAAAAAAAAAAAAAAAAAAAAODO1vX7HgBP5yoN/3sNgACxAxLEDkgQOyBB7IAEsQMSxA5IEDsgQeyABLEDEsQOSBA7IEHsgASxAxLEDkgQOyBB7IAEsQMSxA5IEDsgQeyABLEDEsQOSBA7IEHsgASxAxLE7kbmeX4GAAAAAAAAAAAAAAAAAAAAAAAAwDUs237MAfBwP2UHEp1mdkFlAAAAAElFTkSuQmCC) no-repeat 24px 8px;
  margin: .8rem 0;
}

.rQf8Kx2_t1s6G9S7vLzB .deadline>.deadline-icon {
  margin-right: .8rem;
  width: 1.7067rem;
  height: 1.7067rem;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url(/webx/xc/mobile/svg/ic-daoshu.f3a0.svg);
}


.rQf8Kx2_t1s6G9S7vLzB .deadline>div {
  margin-left: .6rem;
}



.rQf8Kx2_t1s6G9S7vLzB .deadline>div>div {
  color: #1e1e1e;
  margin-bottom: .2133rem;
  width: 100%;
  text-align: left;
  font-size: .64rem;
}

.rQf8Kx2_t1s6G9S7vLzB .deadline>div>div {
  color: #1e1e1e;
  margin-bottom: .2133rem;
  width: 100%;
  text-align: left;
  font-size: .64rem;
}


.rQf8Kx2_t1s6G9S7vLzB .deadline>div>div>span {
  color: #f52d2d;
  font-size: 14px;
  font-weight: bold;
  margin: 0px 2px;
}


.rQf8Kx2_t1s6G9S7vLzB .qr-code>.info {
  margin-top: .3333rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  font-size: .64rem;
}


.rQf8Kx2_t1s6G9S7vLzB .qr-code>.info>.title {
  color: #666;
  margin-bottom: .6rem;
  display: flex;
  justify-content: space-between;
}

.rQf8Kx2_t1s6G9S7vLzB .qr-code>.info>.title>.type {
  color: #ff5223;
  font-size: .74667rem;
}


.rQf8Kx2_t1s6G9S7vLzB .qr-code>.info>.code-url-box {
  display: flex;
  justify-content: space-between;
}


.rQf8Kx2_t1s6G9S7vLzB .qr-code>.info>.code-url-box .code-url {
  word-wrap: break-word;
  width: 88%;
}


.rQf8Kx2_t1s6G9S7vLzB .qr-code>.info>.code-url-box .rigcopy {
  color: #a17df5;
  font-size: .74667rem;
  padding-right: 0rem;
}

.rQf8Kx2_t1s6G9S7vLzB .qr-code>.image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: .8rem;
}

.rQf8Kx2_t1s6G9S7vLzB .qr-code>.image>p {
  margin-top: 10px;
  background: linear-gradient(90deg, #FF804B, #EE5A5A);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: rgba(0, 0, 0, 0);
  color: rgba(0, 0, 0, 0);
  font-size: 12px;
  font-weight: 400;
}


.rQf8Kx2_t1s6G9S7vLzB div.submit {
  text-align: center;
  background: url(/webx/xc/mobile/svg/btn-bg.59b2.svg) no-repeat 0px -1.25rem;
  background-size: 100%;
  border-radius: .5rem;
  width: 100%;
  height: 4rem;
  font-size: 15px;
  letter-spacing: 1px;
  line-height: 3rem;
  color: #fff;
  margin: auto;
  margin-bottom: 1rem;
}



.rQf8Kx2_t1s6G9S7vLzB .tips {
  margin-top: .5333rem;
}


.rQf8Kx2_t1s6G9S7vLzB .warning {
  padding-left: .8rem;
  background-size: auto;
  background-position: left center;
  background-repeat: no-repeat;
  background-image: url(/webx/xc/mobile/svg/warning.190e.svg);
}


.rQf8Kx2_t1s6G9S7vLzB .tips>div {
  font-size: 14px;
  font-weight: 550;
  margin-bottom: .2667rem;
}


.rQf8Kx2_t1s6G9S7vLzB .tips .lightTipsTexts {
  font-size: 14px;
  font-weight: 550;
  margin-bottom: .2667rem;
  color: #121b47;
}



.rQf8Kx2_t1s6G9S7vLzB .tips .Texts_p {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.0667rem;
  color: #99a0b1;
}

.btnCustom {

  border: 1px solid #A787E7;
  background: #A787E7;
  color: #fff;
}

.rQf8Kx2_t1s6G9S7vLzB .detail-info {
  border-radius: .3733rem;
}


.rQf8Kx2_t1s6G9S7vLzB .white-bg {
  padding: 0 1rem;
}


.rQf8Kx2_t1s6G9S7vLzB .tips {
  margin-top: .5333rem;
}

.fg6ZfskHOnqaRwP2znAd {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  top: 0;
  left: 0;
  position: fixed;
  //transform: translateZ(500px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.Zs5THLqQY4yVfXvDwk9p {
  height: 100%;
  position: absolute;
  width: 100%;
  left: 0;
  z-index: 1;
  background: #f5f7fb;
  border-top-left-radius: 1.066667rem;
  border-top-right-radius: 1.066667rem;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, .2), 0px 24px 38px 3px rgba(0, 0, 0, .14), 0px 9px 46px 8px rgba(0, 0, 0, .12);
  //transform: translate3d(0, 100%, 0);
  animation: an-pop-up .5s forwards;
  overflow: hidden;
}

.Zs5THLqQY4yVfXvDwk9p {
  background: #fff;
}

.Zs5THLqQY4yVfXvDwk9p.popup_fixed {
  position: fixed;
}

.dXKrZR0vnzQaeb_ExfRi {
  height: 2.4rem;
  justify-content: space-between;
  align-items: center;
  display: flex;
  width: 100%;
  border-bottom: 1px solid #eceaea;
}

.dXKrZR0vnzQaeb_ExfRi>div.left {
  width: 10%;
}

.dXKrZR0vnzQaeb_ExfRi>div.left>svg {
  font-size: .8533rem;
  padding: .64rem .4rem;
}

.dXKrZR0vnzQaeb_ExfRi>div.center {
  width: 80%;
  text-align: center;
  line-height: 2.4rem;
  color: #211627;
  font-size: .8533rem;
  font-weight: 400;
}

.dXKrZR0vnzQaeb_ExfRi>div.right {
  width: 10%;
  text-align: center;
}

.dXKrZR0vnzQaeb_ExfRi>div.right img {
  width: 22px;
  height: 22px;
}

.Zs5THLqQY4yVfXvDwk9p>.wrapper {
  height: calc(100% - 2.4rem);
  margin-top: 2.4rem;
  overflow: scroll;
  overscroll-behavior: contain;
  box-sizing: border-box;
  position: relative;
}

.Zs5THLqQY4yVfXvDwk9p>.wrapper.op-popup {
  margin-top: 0;
  height: calc(98% - 2.4rem);
}


.v-container {
  width: 100%;
  padding: 16px;
  margin-right: auto;
  margin-left: auto;
}

.v-locale--is-ltr {
  direction: ltr;
}

.v-container {
  max-width: 540px !important;
}

.mobileArea[data-v-e386b449] {
  margin-top: 10px;
  margin-bottom: 40px;
  padding: 0 !important;
}

#test[data-v-e386b449] {
  padding-bottom: 150px !important;
}

.mb-3 {
  margin-bottom: 12px !important;
}

.card-inner {
  padding: 12px 20px !important;
  border-radius: 8px !important;
  -webkit-box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, .1019607843) !important;
  box-shadow: 0 8px 12px #0000001a !important;
  background-color: var(--v-theme-card);
  position: relative;
}

.card-inner {
  padding: 12px !important;
}


.v-card__loader {
  inset: 0 0 auto;
  position: absolute;
  width: 100%;
  z-index: 1;
}

.v-row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin: -12px;
}

.justify-center {
  -webkit-box-pack: center !important;
  -webkit-justify-content: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
}

.align-center {
  -webkit-box-align: center !important;
  -webkit-align-items: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}

.pa-3 {
  padding: 12px !important;
}

.v-col-12 {
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 100%;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.pa-0 {
  padding: 0 !important;
}

.input-group {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap !important;
  -ms-flex-wrap: nowrap !important;
  flex-wrap: nowrap !important;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
  height: 32px;
}


.d-flex {
  display: -webkit-box !important;
  display: -webkit-flex !important;
  display: -ms-flexbox !important;
  display: flex !important;
}



.field-title[data-v-e386b449] {
  width: 42vw;
}
.field-title[data-v-e386b449] {
  color: var(--v-theme-fieldTitle);
}

.d-flex {
  display: -webkit-box !important;
  display: -webkit-flex !important;
  display: -ms-flexbox !important;
  display: flex !important;
}
.field-title-input[data-v-e386b449], .field-title-input-name[data-v-e386b449] {
  width: 100%;
}


.rounded {
  border-radius: 4px !important;
}

.v-input {
  display: grid;
  -webkit-box-flex: 1;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.v-input--disabled {
  pointer-events: none;
}





.bank_money{
  //background-color: #FFFFFF;width: 31%;text-align: center;border: 1px solid #E8E5E5;height: 28px;line-height: 28px;color: #000

  padding: 0 10px;
  height: 34px;
  line-height: 34px;
  color: #9486c4;
  background: linear-gradient(180deg, #faf9ff 0%, #eeebff 100%);
  border-radius: 4px;
  text-align: center;
  font-size: 0.7179rem;
  font-weight: 400;
  box-sizing: border-box;
}


.bank_money_active{
  border: 1px solid #A787E7;background: #A787E7;;width: 31%;text-align: center;border: 1px solid #E8E5E5;height: 28px;line-height: 28px;color: #fff
}



.M8dRW6CpOtBocJbOnJpq .quick-money-selector>span {
  padding: 0 10px;
  height: 34px;
  line-height: 34px;
  color: #9486c4;
  background: linear-gradient(180deg, #faf9ff 0%, #eeebff 100%);
  border-radius: 4px;
  text-align: center;
  font-size: .7179rem;
  font-weight: 400;
  box-sizing: border-box;
}
.M8dRW6CpOtBocJbOnJpq .quick-money-selector .usdt_money_active{
  border: 1px solid #A787E7;
  background: #A787E7;
  color: #fff;
}


 .quick-money-selector {
  box-sizing: border-box;
  border-radius: 0 0 2px 2px;
  border-top: none;
  margin: .2667rem 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: .4rem;
}


.quick-money-selector>span {
  padding: 0 10px;
  height: 34px;
  line-height: 34px;
  color: #9486c4;
  background: linear-gradient(180deg, #faf9ff 0%, #eeebff 100%);
  border-radius: 4px;
  text-align: center;
  font-size: .7179rem;
  font-weight: 400;
  box-sizing: border-box;
}

.quick-money-selector .usdt_money_active{
  border: 1px solid #A787E7;
  background: #A787E7;
  color: #fff;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: #212529;
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.375rem;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.amount-btn .btn-primary {
  font-size: 14px;
  padding: 4px 8px !important;
}


.amount-btn .btn {
  color: #bcbcbc !important;
  border-color: #ced4da !important;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.btn.btn-card2 {
  width: 100% !important;
  background: linear-gradient(to bottom, #fff, #e5f5ff) !important;
  margin: 0 auto !important;
}

.amount-btn .btn.active, .amount-btn .btn:hover {
  color: #fff !important;
  background-color: #fff !important;
  border: 1px solid #A787E7 !important;
}
.amount-btn .btn.active {
  color: #fff !important;
  border: 1px solid #A787E7;
  background: #A787E7;
  position: relative;
  overflow: hidden;
}
.bg-grey, .btn-card2, .btn.active.btn-card2 {
  width: 100% !important;
  margin: 0 auto !important;
  background: #A787E7 !important;
}
.bg-grey, .btn-card2, .btn.active.btn-card2 {
  width: 100% !important;
  margin: 0 auto !important;
}

.btn-card2 .text01, .text-inpo .title-txt, ol li {
  font-size: 14px;
  line-height: 20px;
}

.btn-card2 .text01, .font-weight, .order-list-bluebg .bg-light_blue p, .result-txt, .result-txt-red {
  font-weight: 700;
}

.active .text01 {
  color: #000 !important;
}

.btn-card2 .text02 {
  font-size: 12px;
  line-height: 18px;
}



</style>


